import React from 'react'
import { IconButton } from '@/components/common/icon-button'
import { LeftIcon } from '@/components/ui/icon'
import { useNavigate } from 'react-router-dom'
import { agentsHooks } from '@/manager/manager/agent-manager'
import { TruncatedText } from '@/components/common/truncated-text'
import { Image } from '@/components/common/image';

export const DashboardHeader = () => {
  const navigate = useNavigate();
  const { agent } = agentsHooks.useCurrentAgent();

  const handleClick = () => {
    navigate(`/agent/creation/${agent.id}/`);
  }

  return (
    <header className='flex max-h-[6rem] items-center p-8 pb-4 border-b border-[rgba(234,236,240,1)] '>
      <div className='mr-7'>
        <IconButton
          icon={<LeftIcon />}
          className='size-10 border border-[rgba(208,213,221,1)] rounded-[8px] hover:bg-gray-50'
          onClick={handleClick}
        />
      </div>

      <div className="flex items-center">
        <div className="size-12 rounded-full bg-[#2b2f38] flex items-center justify-center mr-3.5">
          <Image src={agent?.avatar} className="size-full rounded-full object-cover" />
        </div>

        <div className="flex flex-col">
          <div className="text-lg font-medium text-[rgba(16,24,40,1)] mb-1">
            <TruncatedText text={agent?.name} className='w-128' />
          </div>
          <div className="text-sm text-[rgba(102,112,133,1)]">
            <TruncatedText text={agent?.intro} className='w-128' />
          </div>
        </div>
      </div>
    </header>
  )
}
